import { useState, useImperativeHandle, forwardRef } from "react";
import { monthNames } from "./resource";

const TimeSlots = forwardRef((props, ref) => {
  const { selectedDate, timeSlots, onSelectNext } = props;

  const [selectedTime, setSelectedTime] = useState("");

  const formatSelectedDate = () => {
    if (!selectedDate) return "No date selected";
    const date = new Date(selectedDate + "T00:00:00"); // safely interpreted in local time
    const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
    const monthName = monthNames[date.getMonth()];
    const day = date.getDate();
    return `${dayName}, ${monthName} ${day}`;
  };

  useImperativeHandle(ref, () => ({
    resetTime: () => {
      setSelectedTime(null);
    },
  }));

  const handleTimeSelect = (time) => {
    setSelectedTime(time);
    onSelectNext(time);
  };

  return (
    <>
      {selectedDate ? (
        <>
          <div className="mb-4">
            <h3 className="text-lg font-medium text-gray-900">
              {formatSelectedDate()}
            </h3>
          </div>

          <div className="grid grid-cols-4 gap-4">
            {timeSlots.map((time) => (
              <div
                key={time}
                // className="relative w-full h-12 overflow-hidden rounded-md"
                className="relative w-full h-12 rounded-md"
              >
                {/* Sliding container */}
                <div className="flex h-full">
                  {/* Original button - takes up first half */}
                  <button
                    onClick={() =>
                      selectedTime === time
                        ? props.continue()
                        : handleTimeSelect(time)
                    }
                    className={`w-full h-full px-[4px] py-[4px] border text-center transition-colors rounded-md
                    ${
                      selectedTime === time
                        ? "border-blue-600 bg-blue-600 text-white"
                        : "border-blue-200 bg-blue-50 text-blue-600 hover:border-blue-300 hover:bg-blue-100"
                    }
                  `}
                  >
                    {selectedTime === time ? (
                      // Selected state - show time and continue action
                      <div className="flex flex-col items-center justify-center h-full">
                        <span className="text-xs font-semibold leading-tight">
                          {time}
                        </span>
                        <div className="flex items-center gap-1 mt-0.5">
                          <span className="text-xs font-medium opacity-90">
                            Continue
                          </span>
                          <svg
                            className="w-3 h-3 opacity-90"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 5l7 7-7 7"
                            />
                          </svg>
                        </div>
                      </div>
                    ) : (
                      // Unselected state - show only time
                      <span className="text-sm font-medium">{time}</span>
                    )}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="text-center text-gray-500 py-8">
          <p className="text-sm">Select a date to see available times</p>
        </div>
      )}
    </>
  );
});

export default TimeSlots;
